import React from "react";
import { Container, Row, Col } from "shards-react";
import axios from "axios";

import baseURL from "../components/common/axios-config";
import PageTitle from "../components/common/PageTitle";
import CheckAnomaly from "../components/anomalies/CheckAnomaly";

export default class Anomalies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkAnomaly: [],
    };
  }

  getCheckAnomaly() {
    axios(baseURL + "/anomalies-checkAnomaly", {
      method: "POST",
      withCredentials: true,
    }).then((res) => {
      if (res.data.result === true) {
        this.setState({
          checkAnomaly: res.data.data || [],
        });
      }
    });
  }

  componentDidMount() {
    this.getCheckAnomaly();
  }
  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="Anomalies"
            subtitle="Dashboard"
            className="text-sm-left mb-3"
          />
        </Row>
        <Row>
          <Col md="12" sm="12" className="mb-4">
            <CheckAnomaly
              title="Visualisation des anomalies"
              data={this.state.checkAnomaly}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}
